module.exports = "/images/illness-or-injury.png?13d0238404d3a33728ff51ca4d5dc493";